/**
 * "Quantity available" cell of the desktop check-inventory table: the batch's quantity truncated to
 * two decimals, or "Loading..." while fetching or when the row has no quantity (the placeholder
 * row before batches arrive).
 */
import { truncateNumber } from "@components/Helper/common";
import { useApplication } from "@ryerson/frontend.application";
import { Flex } from "@ryerson/frontend.layout";
import { useTheme } from "@ryerson/frontend.theme";
import { Typography } from "@ryerson/frontend.typography";
import { formatNumber } from "@utils/NumberFormatUtil";
import React from "react";
import { CheckInventoryContent } from "../CheckInventoryModalContent";

interface CheckInventoryModalTableQtyAvailableCellProps {
	rowData: any;
	fetching: boolean;
}

/** The row's `quantityAvailable`, or "Loading..." while `fetching` or when it is missing or 0. */
const CheckInventoryModalTableQtyAvailableCell: React.FC<
	CheckInventoryModalTableQtyAvailableCellProps
> = ({ rowData, fetching }) => {
	const { theme } = useTheme();
	const { darkGray } = theme.colors.primary;

	const {
		localization: { language },
	} = useApplication();
	const content = CheckInventoryContent[language];

	return (
		<Flex justifyContent="center">
			<Typography color={darkGray}>
				{!fetching && rowData.quantityAvailable ? (
					formatNumber(truncateNumber(rowData.quantityAvailable, 2))
				) : (
					<Flex>
						<Typography css={{ padding: "40px 0 40px 80px" }}>
							{content.loading}
						</Typography>
					</Flex>
				)}
			</Typography>
		</Flex>
	);
};

export default CheckInventoryModalTableQtyAvailableCell;
